var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCberrySplashLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Components",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.8497 79.9583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e5e1e6;\n      }\n\n      .cls-2 {\n        fill: #ff3eb5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9e9c32ca-8b32-42d7-a8ad-c5d996e8fe86_4",
    "data-name": "9e9c32ca-8b32-42d7-a8ad-c5d996e8fe86@4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 52.2381,
    cy: 33.1709,
    r: 4.8123
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 28.6128,
    cy: 28.6128,
    r: 4.8123,
    transform: "translate(-4.9176 51.2645) rotate(-79.0413)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.5033,
    cy: 51.3507,
    r: 4.8123
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.9729,18.9954c-7.8162-1.508-15.4024,3.6244-16.9104,11.4406-.233,1.2074-1.1734,6.7104,2.9673,11.824l3.2474-3.6884c-2.0075-2.9579-1.7482-5.8834-1.4896-7.224,1.0053-5.2108,6.0628-8.6324,11.2736-7.6271,5.2108,1.0053,8.6324,6.0628,7.627,11.2736-.7907,4.0984-4.088,7.0896-7.9952,7.6913.7327,1.4508,1.2766,2.9867,1.6238,4.5896,5.4628-1.2,9.9714-5.5378,11.0965-11.3693,1.508-7.8162-3.6244-15.4024-11.4406-16.9104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.3358,45.7869c2.1239,3.0025,1.8529,6.037,1.5933,7.3823-1.0069,5.2191-6.0539,8.6341-11.273,7.6272-5.9838-1.1545-9.2989-7.4414-7.139-12.9637-.8452-.049-1.6969-.1545-2.5509-.3193-.7657-.1477-1.5125-.3391-2.2372-.5711-2.6213,8.2253,2.4875,16.9333,11.0156,18.5786,7.8284,1.5104,15.3994-3.6117,16.9097-11.4401.1277-.662,1.3835-6.6051-3.08-11.972l-3.2385,3.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.9292,41.5953c-.7094-1.4549-1.2387-3.0042-1.5645-4.6133-1.9233,1.0939-4.2321,1.5332-6.5752,1.0811-5.2191-1.0069-8.634-6.0545-7.627-11.2736s6.0545-8.634,11.2736-7.6271c2.3431.4521,4.3228,1.7187,5.7011,3.4496.901-1.3724,1.9687-2.6136,3.1684-3.7002-2.0254-2.2361-4.7669-3.8589-7.9579-4.4746-7.8289-1.5104-15.3999,3.6116-16.9104,11.4406-1.5105,7.829,3.6116,15.3999,11.4406,16.9104,3.191.6156,6.3394.1292,9.0513-1.1929Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCberrySplashLogo);
export default __webpack_public_path__ + "static/media/cberry-splash-logo.19d13b5045e79851ad22013350aebf70.svg";
export { ForwardRef as ReactComponent };